import React, { useContext, useEffect, useState } from "react";
//import { AuthContext } from "../AuthContext";
import {
  getAgreementEquipmentsList,
  submitAgreementEquipments,
} from "../services/agreementServices";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
//import AgmEquipmentCard from "./AgmEquipmentCard";
import { AuthContext } from "../AuthContext";
import AgreementInfo from "./AgreementInfo";
import EquipmentsTable from "./EquipmentsTable";
import EquipmentConflictDialog from "./EquipmentConflictDialog";
import {
  SUBMIT_FORBIDDEN_MESSAGE,
  conflictFromError,
  isSubmitForbidden,
} from "../utils/equipmentConflicts";

const AgmConfirmEquimentsDialog = (props) => {
  const {
    onClose,
    open,
    agreementId,
    formStatus = false,
    onEdit,
    viewMode,
  } = props;
  const { ctxStEquipments, setCtxStEquipments, group, APP_ENV } =
    useContext(AuthContext);
  const [equipmentList, setEquipmentList] = useState([]);
  const [syncError, setSyncError] = useState("");
  const [loadingMsg, setLoadingMsg] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [equipmentsListSizeError, setEquipmentListSizeError] = useState("");
  const [disableConfirmButton, setDisableConfirmButton] = useState(false);
  // ADO #334: the submit Lambda refused the equipment. This dialog is read-only, so the way back
  // to the rows is its own Edit button.
  const [conflict, setConflict] = useState(null);


  useEffect(() => {
    setFormSubmitted(formStatus);
    console.log(group, "group...");
  }, [formStatus]);

  const getSyncEquipments = (agreementId) => {
    setEquipmentListSizeError("");
    setFormSubmitted(true);
    console.log("Sync Equipment Dialog", agreementId);
    setEquipmentList([]);
    setLoadingMsg("Loading Equipment. Please Wait..");
    getAgreementEquipmentsList(agreementId.id)
      .then(
        (res) => {
          const eqList = APP_ENV === "Development" ? res.data.body : res.data;
          const statusCode = res.status;
          if (statusCode === 200) {
            console.log("Sync Equipment Dialog equipment list :", eqList);
            if (eqList && eqList.length > 0) {
              if (eqList.length > 5) {
                setEquipmentListSizeError(
                  "Only 5 Equipment records are allowed for the agreement. Please remove additional equipment to create an agreement."
                );
              } else {
                setEquipmentListSizeError("");
              }
              //setEquipmentList(eqList);
              setCtxStEquipments(eqList);
              setLoadingMsg("");
              setFormSubmitted(false);
            } else {
              setLoadingMsg("No Equipment found");
              setFormSubmitted(false);
            }
          }
        },
        (err) => {
          console.log("unable to load Equipment list", err);
          //setSaveError("unable to load equipment list");
          setFormSubmitted(false);
        }
      )
      .catch((err) => {
        console.log("Equipment List Internal Server Error", err);
        //setSaveError("Internal Server error");
        setFormSubmitted(false);
      });
  };

  useEffect(() => {
    if (agreementId) {
      getSyncEquipments(agreementId);
    }
    //setFormStatus(false);
  }, [agreementId]);

  const handleClose = (event, reason) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }
    //setSaveError("");
    onClose("close");
  };

  const handleEdit = () => {
    onEdit(agreementId);
  };

  const handleSave = (override = false) => {
    if (equipmentList.length > 5) {
      return;
    }
    setFormSubmitted(true);
    submitAgreementEquipments(agreementId.id, override)
      .then(
        (res) => {
          const statusCode = res.status;
          const data = res.data;
          console.log("sync result :", data);
          if (statusCode === 200) {
            onClose("success");
            setFormSubmitted(false);
          } else {
            setSyncError("Unable to Submit Equipment");
            setFormSubmitted(false);
          }
        },
        (err) => {
          console.log("Equipment Submit error :", err);
          setFormSubmitted(false);
          const refused = conflictFromError(err);
          if (refused) {
            setConflict(refused);
            return;
          }
          if (isSubmitForbidden(err)) {
            setSyncError(SUBMIT_FORBIDDEN_MESSAGE);
            return;
          }
          setSyncError("Error :", err);
        }
      )
      .catch((err) => {
        console.error("Equipment Submit internal server error :", err);
        setSyncError("Internal server error");
        setFormSubmitted(false);
      });
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      PaperProps={{
        component: "div",
      }}
      fullWidth={true}
      maxWidth={"xl"}
      disableEscapeKeyDown
    >
      <DialogTitle>
        {viewMode ? "View Agreement Details" : "Confirm Equipment List"}
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} padding={3}>
          <Grid item xs={12}>
            <AgreementInfo
              agreement={agreementId}
              showAgreementTable={viewMode ? true : false}
              formType="confirm"
            />
          </Grid>
          {ctxStEquipments.length > 0 ? (
            <Grid item xs={12}>
              <EquipmentsTable
                selectedInvoice={agreementId}
                showAction={false}
                formType="confirm"
                onAgreementUnitSizeExceed={(value)=>setDisableConfirmButton(value)}
              />
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Typography
                color="secondary"
                variant="caption"
                component="span"
                align="left"
                sx={{ fontSize: "14px" }}
              >
                {loadingMsg}
              </Typography>
            </Grid>
          )}
          {ctxStEquipments.length > agreementId?.equipmentUnitSize && (
            <Grid item xs={8} align="right">
              <Typography
                variant="captiondo"
                component="subtitle1"
                align="left"
                sx={{ fontSize: "14px" }}
              >
                Error : Total Equipments Count must not be greater then {agreementId.equipmentUnitSize}
              </Typography>
            </Grid>
          )}
        </Grid>

        {syncError && (
          <Typography
            variant="body"
            component="span"
            sx={{ color: "#f44336", fontSize: "10px" }}
          >
            {syncError}
          </Typography>
        )}
        {equipmentsListSizeError && (
          <Typography
            variant="body"
            component="span"
            sx={{ color: "#f44336", fontSize: "10px" }}
          >
            {equipmentsListSizeError}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        {(!viewMode || group === "jbw-admin") && (
          <Button
            disabled={formSubmitted ? true : false}
            onClick={handleEdit}
            color="success"
          >
            Edit
          </Button>
        )}
        <Button
          disabled={formSubmitted ? true : false}
          onClick={handleClose}
          color="warning"
        >
          Cancel
        </Button>
        {!viewMode && (
          <Button
            disabled={
              formSubmitted ||
              equipmentsListSizeError || disableConfirmButton ||
              !ctxStEquipments.length > 0
                ? true
                : false
                || 
                ctxStEquipments.length > agreementId?.equipmentUnitSize
            }
            onClick={() => handleSave()}
          >
            Confirm
          </Button>
        )}
      </DialogActions>
      <EquipmentConflictDialog
        conflict={conflict}
        canOverride={group === "jbw-admin"}
        onBack={() => {
          setConflict(null);
          handleEdit();
        }}
        onOverride={() => {
          setConflict(null);
          handleSave(true);
        }}
      />
    </Dialog>
  );
};

export default AgmConfirmEquimentsDialog;
